import React, { useState } from 'react';
import Inputs from '../../share/input/Inputs';
import Toggle from '../../share/input/Toggle';
import IconButton from '../../share/buttons/IconButton';
import { useForm, Controller } from 'react-hook-form';
import { AiOutlinePlus, AiOutlineMinus } from 'react-icons/ai';
import { BtnPrimary } from '../../share/buttons/Btn';

function PriceForm(props) {
	const {
		handleSubmit,
		control,
		register,
		reset,
		formState: { errors, isSubmitted },
	} = useForm();
	const onSubmit = (data) => {
		console.log('first');
	};
	const [num, setNum] = useState([0, 0]);
	const [totalPrice, setTotalPrice] = useState(0);
	const handleIncreasePrice = (i) => {
		let before = [...num];
		before[i] += 1;
		setNum(before);
	};

	// decrease price
	const handleDecreasePrice = (i) => {
		let before = [...num];
		if (before[i] > 0) {
			before[i] -= 1;
			setNum(before);
		} else {
			before[i] = 0;
			setNum(before);
			if (before[i] > 0) {
			}
		}
	};
	return (
		<div className='w-full'>
			<form onSubmit={handleSubmit(onSubmit)} className=' w-full'>
				<div className=' bg-white-dark border-[#21212182] border-[1px] border-solid rounded-[1.6rem] py-[2.7rem] px-[2.9rem] w-full flex items-center justify-between price__form'>
					<p className=' text-primary-dark text-[1.6rem] font-bold leading-[3.2rem]'>
						پلتفرم برگزاری
					</p>
					<div className='flex items-center justify-center gap-16'>
						<div className=' flex items-center justify-start '>
							<label
								htmlFor='4go'
								className=' text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center'
							>
								<input
									{...register('course', { required: true })}
									type='radio'
									name='coursetype'
									value='4go'
									className='form-check-input PriceForm radio-lg ml-[0.8rem]'
									id='4go'
									checked
								/>{' '}
								اسکای روم
							</label>
						</div>
						<div className=' flex items-center justify-start  '>
							<label
								htmlFor='4go'
								className=' text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center'
							>
								<input
									{...register('course', { required: true })}
									type='radio'
									name='coursetype'
									value='4go'
									className='form-check-input PriceForm radio-lg ml-[0.8rem]'
									id='4go'
								/>{' '}
								ادوبی کانکت
							</label>
						</div>
						<div className=' flex items-center justify-start  '>
							<label
								htmlFor='4go'
								className=' text-[#212121E5] text-[1.4rem] leading-[2.4rem] font-normal flex flex-row items-center'
							>
								<input
									{...register('course', { required: true })}
									type='radio'
									name='coursetype'
									value='4go'
									className='form-check-input PriceForm radio-lg ml-[0.8rem]'
									id='4go'
								/>{' '}
								بیگ بلو باتن
							</label>
						</div>
					</div>
				</div>
				<div>
					<div className=' bg-white-dark border-[#21212182] border-[1px] border-solid rounded-[1.6rem] py-[2.7rem] px-[2.9rem] w-full flex items-center justify-between mt-[1.6rem] price__form'>
						<p className=' text-primary-dark text-[1.6rem] font-bold leading-[3.2rem]'>
							تعداد شرکت کنندگان
						</p>
						<div className=' flex items-center justify-center'>
							<IconButton
								className='px-[1rem] py-[0.9rem] rounded-[1rem] ml-[0.3rem] bg-purple hover:bg-purple-dark'
								text='اضافه کردن تعداد'
								type='button'
								onClick={() => handleIncreasePrice(0)}
							>
								<AiOutlinePlus className=' text-[1.6rem] text-[#fff] ' />
							</IconButton>
							<div className=''>
								<Inputs
									register={{
										required: {
											value: true,
											message: 'choose a number',
										},
									}}
									type='number'
									name='company_name'
									control={control}
									className=' rounded-[10px] border-[#21212182] border-[1px] border-solid py-[0.7rem] px-[0.6rem] text-center bg-[#F2F3F5] w-[6.3rem] h-[3.3rem] text-[1.6rem] leading-[3.2rem] text-[#212121E5] placeholder:text-[#212121E5] focus:outline-none'
									placeholder='0'
									value={num[0]}
								/>
							</div>

							<IconButton
								className='px-[1rem] py-[0.9rem] rounded-[1rem] mr-[0.3rem] bg-black-prim opacity-[51%] hover:bg-black-prim hover:opacity-[71%]'
								disabled={num < 1}
								text='کم کردن تعداد'
								type='button'
								onClick={() => handleDecreasePrice(0)}
							>
								<AiOutlineMinus className=' text-[1.6rem] text-[#fff] ' />
							</IconButton>

							<p className=' mr-[1rem] text-[1.4rem] leading-[2.4rem]'>
								نفر
							</p>
						</div>
					</div>
					<p className=" mt-[0.8rem]  text-[#21212199]  text-[1.2rem] before:content-['\00b7'] before:text-[2rem] before:top-0  font-normal leading-[2.4rem]">
						منظور تعداد شرکت کنندگان همزمان است.
					</p>
				</div>
				<div>
					<div className=' bg-white-dark border-[#21212182] border-[1px] border-solid rounded-[1.6rem] py-[2.7rem] px-[2.9rem] w-full flex items-center justify-between mt-[1.6rem] price__form'>
						<p className=' text-primary-dark text-[1.6rem] font-bold leading-[3.2rem]'>
							حجم فضای مورد استفاده{' '}
						</p>
						<div className=' flex items-center justify-center'>
							<IconButton
								className='px-[1rem] py-[0.9rem] rounded-[1rem] ml-[0.3rem] bg-purple hover:bg-purple-dark'
								text='اضافه کردن تعداد'
								type='button'
								onClick={() => handleIncreasePrice(0)}
							>
								<AiOutlinePlus className=' text-[1.6rem] text-[#fff] ' />
							</IconButton>
							<div className=''>
								<Inputs
									register={{
										required: {
											value: true,
											message: 'choose a number',
										},
									}}
									type='number'
									name='company_name'
									control={control}
									className=' rounded-[10px] border-[#21212182] border-[1px] border-solid py-[0.7rem] px-[0.6rem] text-center bg-[#F2F3F5] w-[6.3rem] h-[3.3rem] text-[1.6rem] leading-[3.2rem] text-[#212121E5] placeholder:text-[#212121E5] focus:outline-none'
									placeholder='0'
									value={num[0]}
								/>
							</div>

							<IconButton
								className='px-[1rem] py-[0.9rem] rounded-[1rem] mr-[0.3rem] bg-black-prim opacity-[51%] hover:bg-black-prim hover:opacity-[71%]'
								disabled={num < 1}
								text='کم کردن تعداد'
								type='button'
								onClick={() => handleDecreasePrice(0)}
							>
								<AiOutlineMinus className=' text-[1.6rem] text-[#fff] ' />
							</IconButton>

							<p className=' mr-[1rem] text-[1.4rem] leading-[2.4rem]'>
								گیگا بایت
							</p>
						</div>
					</div>
					<p className=" mt-[0.8rem]  text-[#21212199]  text-[1.2rem] before:content-['\00b7'] before:text-[2rem] before:top-0  font-normal leading-[2.4rem]">
						بر اسای میزان حجم فایل هایی که برای این دوره آپلود خواهید کرد.{' '}
					</p>
				</div>
				<div>
					<div className=' bg-white-dark border-[#21212182] border-[1px] border-solid rounded-[1.6rem] py-[2.7rem] px-[2.9rem] w-full flex items-center justify-between mt-[1.6rem] price__form'>
						<p className=' text-primary-dark text-[1.6rem] font-bold leading-[3.2rem]'>
							لینک اختصاصی
						</p>
						<div className=' flex items-center justify-center '>
							<p className=' ml-[1rem] text-[1.4rem] leading-[2.4rem]'>
								غیر فعال
							</p>

							<Toggle
								name='Toggle'
								control={control}
								className=' before:bg-[#21212182]'
								classNameswitch='w-[6.3rem] h-[3.3rem] '
							/>

							<p className=' mr-[1rem] text-[1.4rem] leading-[2.4rem]'>
								فعال
							</p>
						</div>
					</div>
				</div>
				<div>
					<div className=' bg-white-dark border-[#21212182] border-[1px] border-solid rounded-[1.6rem] py-[2.7rem] px-[2.9rem] w-full flex items-center justify-between mt-[1.6rem] price__form'>
						<p className=' text-primary-dark text-[1.6rem] font-bold leading-[3.2rem]'>
							صفحه اختصاصی{' '}
						</p>
						<div className=' flex items-center justify-center '>
							<p className=' ml-[1rem] text-[1.4rem] leading-[2.4rem]'>
								غیر فعال
							</p>

							<Toggle
								name='Toggle'
								control={control}
								className=' before:bg-[#21212182]'
								classNameswitch='w-[6.3rem] h-[3.3rem] '
							/>

							<p className=' mr-[1rem] text-[1.4rem] leading-[2.4rem]'>
								فعال
							</p>
						</div>
					</div>
				</div>
				<div
					className={`flex items-center price__button ${
						props.showBtn ? 'justify-between' : 'justify-center'
					} mt-[3.2rem]`}
				>
					<p className=' text-[#41284E] font-bold text-[2rem]'>
						هزینه تنظیمات انتخابی شما ۱٬۵۰۰٬۰۰۰ تومان است.
					</p>
					{props.showBtn && (
						<BtnPrimary
							className='px-[14rem] py-6'
							text='ساخت بوت کمپ'
							type='submit'
							htmlType='submit'
						/>
					)}
				</div>
			</form>
		</div>
	);
}

export default PriceForm;
